import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Card, Pill, PrimaryButton } from '../ui';
import { adminApi, PROGRAM_NAMES } from '../../../pages/journey/journeyApi';
import { AdminStudentDetail } from './AdminStudentDetail';

const LinkExisting = ({ onLinked }) => {
  const [email, setEmail] = useState('');
  const link = async () => {
    try { const r = await adminApi('/link-existing', { method: 'POST', body: { email } }); toast.success(r.created ? 'Unified profile created' : 'Profile already linked'); onLinked(r.student.id); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <Card className="mb-5">
      <p className="text-sm font-semibold text-[#0b1f4d] mb-2">Link an existing student (Talent Network / Readiness Check) by email</p>
      <div className="flex gap-2"><input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="student@email.com" data-testid="admin-link-email-input"
        className="flex-1 border border-slate-200 rounded-xl px-3 py-2 text-sm" /><PrimaryButton onClick={link} disabled={!email} data-testid="admin-link-btn">Link</PrimaryButton></div>
      <p className="text-xs text-slate-500 mt-2">Reuses existing records without duplicating identities. Real students are never shown in the demo student view.</p>
    </Card>
  );
};

export const AdminStudents = ({ catalog }) => {
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = useCallback(() => adminApi('/students').then(setList).catch((e) => toast.error(e.message)), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="grid xl:grid-cols-[340px_1fr] gap-6">
      <div>
        <LinkExisting onLinked={(id) => { load(); setSelected(id); }} />
        <div className="space-y-2" data-testid="admin-student-list">
          {list.map((s) => (
            <button key={s.id} onClick={() => setSelected(s.id)} data-testid={`admin-student-${s.id}`}
              className={`w-full text-left rounded-xl border p-4 bg-white transition-colors ${selected === s.id ? 'border-teal-500' : 'border-slate-200 hover:border-slate-300'}`}>
              <p className="font-medium text-[#0b1f4d]">{s.full_name}</p>
              <p className="text-xs text-slate-500">{s.persona_label} · {s.is_demo ? `demo of ${s.owner_email}` : 'real'}</p>
              <div className="flex flex-wrap gap-1 mt-2">
                <Pill className="bg-slate-100 text-slate-600">Consult: {s.consultation_status}</Pill>
                <Pill className={s.recommendation_status === 'approved' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-50 text-amber-700'}>Rec: {s.recommendation_status}</Pill>
                {s.entitlements.map((e) => <Pill key={e} className="bg-teal-50 text-teal-700">{PROGRAM_NAMES[e]}</Pill>)}
              </div>
            </button>))}
        </div>
      </div>
      <div>{selected ? <AdminStudentDetail key={selected} studentId={selected} catalog={catalog} onChange={load} />
        : <Card className="text-sm text-slate-500">Select a student to record consultation findings, generate and approve the recommendation, and review progress.</Card>}</div>
    </div>
  );
};
